import { NFormTable } from "../../../Shared/NewForms/NFormTable";
import { NFLookupProduct } from "../../../Shared/NewForms/NFLookupProduct";
import { NFIntInput } from "../../../Shared/NewForms/NFIntInput";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { NFLookupAccount } from "../../../Shared/NewForms/NFLookupAccount";
import { NFLookupAccrual } from "../../../Shared/NewForms/NFLookupAccrual";

export const ProductionAndSalesWithPaymentsDetailEmployeeEarnings = () => {
    const tableName = "products";
    const { t } = useTranslation();

    useEffect(() => {}, []);

    return (
        <>
            <NFormTable fieldArray={"employeeEarnings"}>
                <NFLookupProduct
                    title={t("Job")}
                    fieldName="jobId"
                    width={250}
                />
                <NFLookupAccrual
                    title={t("AccrualType")}
                    fieldName="accrualTypeId"
                    width={250}
                />
                <NFIntInput
                    title={t("Coefficient")}
                    fieldName="coefficient"
                    width={200}
                />
                <NFIntInput
                    title={t("Amount")}
                    fieldName="amount"
                    width={200}
                />
                <NFIntInput
                    title={t("NetAmount")}
                    fieldName="netAmount"
                    width={250}
                />
                <NFIntInput
                    title={t("PersonalContributionCompany")}
                    fieldName="personalContributionCompany"
                    width={200}
                />
                <NFIntInput
                    title={t("PersonalContributionEmployee")}
                    fieldName="personalContributionEmployee"
                    width={200}
                />
                <NFIntInput
                    title={t("IncomeTax")}
                    fieldName="incomeTax"
                    width={200}
                />
                <NFLookupAccount
                    title={t("Account")}
                    fieldName="accountId"
                    width={250}
                />
            </NFormTable>
        </>
    );
};
